import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../config';
import * as ActionTypes from './Actiontype';

export const userLogin = (payload, navigate) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ActionTypes.LOGIN_INIT,
      });

      const res = await axios.post(`${API_URL}/api/admin/login`, payload, {});
      if (res.status === 200) {
        dispatch({
          type: ActionTypes.LOGIN_SUCCESS,
          payload: res.data,
        });
        localStorage.setItem('authToken', res?.data?.data?.token);
        navigate('/dashboard');
        toast.success('Login successfully');
      } else {
        dispatch({
          type: ActionTypes.LOGIN_FAIL,
          payload: res.data.message || 'User login failed',
        });
        toast.error('can not login');
      }
    } catch (e) {
      if (e?.response?.data) {
        toast.error(e?.response?.data?.message);
      }
    }
  };
};

export const sendOtp = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch({
      type: ActionTypes.OTP_SEND_INIT,
    });
    axios
      .post(`${API_URL}/api/users/otp`, payload, {})
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          dispatch({
            type: ActionTypes.OTP_SEND_SUCCESS,
            payload: res.data,
          });
          resolve(res);
        } else {
          dispatch({
            type: ActionTypes.OTP_SEND_FAIL,
            payload: res.data?.message || 'Failed to send Otp',
          });
        }
      })
      .catch((error) => {
        console.log('error', error);
        resolve(error);
      });
  });
};
